export default __webpack_public_path__ + "static/media/business.5f12ccb8.png";